import { getConfig } from '@/modules/common/helpers/config';
import { API_TIMEOUTS } from  '../constant';
import { IFileApiConnector } from '@/modules/api/FileApiConnector/IFileApiConnector';
import { BaseConnector } from '@/modules/api/BaseConnector';
import { AddFileResponse } from '@/modules/api/FileApiConnector/mapper';

export class FileApiConnector extends BaseConnector implements IFileApiConnector {
  private static instance: FileApiConnector;
  private static baseUrl = getConfig().api.fileService.url;
  private static scopes = [getConfig().api.fileService.scope];

  public static getInstance(): IFileApiConnector {
    if (!FileApiConnector.instance) {
      FileApiConnector.instance = new FileApiConnector();
    }
    return FileApiConnector.instance;
  }

  private constructor() {
    super(FileApiConnector.baseUrl, FileApiConnector.scopes, API_TIMEOUTS.fileService);
  }

  async addFile(
    fileRef: string,
    fileBlob: Blob,
    fileExtension: 'json' | 'mdb' | 'csv' | 'png' | 'jpg' | 'jpeg' | 'webp' | 'ply' | 'zip',
    category: string,
  ) {
    const formData = new FormData();
    formData.append('file', fileBlob, `${fileRef}.${fileExtension}`);

    return this.put<AddFileResponse, FormData>(`${category}?filename=${fileRef}`, formData, {
      requiredErrorMessage: 'Error persisting a file',
      skipLatest: true,
      config: {
        headers: {},
      },
    });
  }

  async getBlobFileByCategory(fileName: string, category: string): Promise<Blob> {
    return this.get<Blob>(`${category}?filename=${fileName}`, {
      requiredErrorMessage: 'Error fetching a file',
      skipLatest: true,
      config: {
        responseType: 'blob',
      },
    });
  }

  async getBlobFileByUrl(url: string): Promise<Blob> {
    return this.get<Blob>(`${url}`, {
      requiredErrorMessage: 'Error fetching a file',
      skipLatest: true,
      config: {
        responseType: 'arraybuffer',
      },
    });
  }

  async getJsonFileByUrl(url: string, errorMessage?: string): Promise<object> {
    return this.get<object>(`${url}`, {
      requiredErrorMessage: errorMessage ?? 'Error fetching a file',
      skipLatest: true,
      config: {
        responseType: 'json',
      },
    });
  }
}
